import React, { Component, ContextType, ReactElement } from 'react';
import ReactDOM from 'react-dom';

import { __RouterContext as RouterContext } from 'react-router';
import _uuid from 'uuid/v4';

import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { CloseEvent } from '@philips-emr/tws-core/lib/component/types';
import Engine, { EngineContext } from '@philips-emr/tws-engine';
import { isFunction, noop } from '@philips-emr/tws-utils';

import { HpmsCustomDialog } from '..';

import { DialogProps, DialogService } from './dialog-service';

interface DialogManagerProps {
  engine: Engine;
}

@AwesomeComponent({ type: ComponentType.DATA_DISPLAY })
export default class HpmsCustomDialogManager extends Component<DialogManagerProps> {

  public static contextType = RouterContext;

  public context!: ContextType<typeof RouterContext>;

  private unlistenService: () => void = noop;
  private containers: Map<string, HTMLElement> = new Map();

  public openDialog = (dialog: DialogProps): void => {
    const id = _uuid();
    const container = document.createElement('div');
    document.body.append(container);
    const dialogElement = this.createDialog(id, dialog, container);
    this.containers.set(id, container);
    ReactDOM.render(dialogElement, container);
  };

  public componentDidMount(): void {
    this.unlistenService = DialogService.addListener((dialog: DialogProps) => this.openDialog(dialog));
  }

  public componentWillUnmount(): void {
    this.unlistenService();
    this.containers.forEach((container) => container.remove());
  }

  public createDialog(id: string, dialog: DialogProps, container: HTMLDivElement): ReactElement {
    return (
      <RouterContext.Provider value={this.context}>
        <EngineContext.Provider value={{ engine: this.props.engine }}>
          <HpmsCustomDialog
            {...dialog}
            container={container}
            onClose={() => this.onDialogClose(id, dialog)} />
        </EngineContext.Provider>
      </RouterContext.Provider>
    );
  }

  public onDialogClose = (id: string, dialogProps: DialogProps): void => {
    const container = this.containers.get(id);

    if (!container) {
      return;
    }

    container.remove();
    this.containers.delete(id);

    if (isFunction(dialogProps.onClose)) {
      dialogProps.onClose(new CloseEvent());
    }
  };

  public render(): null {
    return null;
  }

}
